import type { IResourceItem } from "@refinedev/core";

import AssessmentOutlined from "@mui/icons-material/AssessmentOutlined";
import DashboardOutlined from "@mui/icons-material/DashboardOutlined";
import PeopleOutlined from "@mui/icons-material/PeopleOutlined";
import PersonOutlined from "@mui/icons-material/PersonOutlined";

/**
|--------------------------------------------------
| Define the resources for the application
|--------------------------------------------------
*/
export const resources: IResourceItem[] = [
  {
    name: "dashboard",
    list: "/",
    meta: {
      label: "resources.dashboard",
      icon: <DashboardOutlined />,
    },
  },
  {
    name: "practitioner",
    list: "/practitioner",
    meta: {
      label: "resources.practitioner",
      icon: <PersonOutlined />,
      requiredRoles: ["OrgAdmin"],
    },
  },
  {
    name: "patients",
    list: "/patients",
    meta: {
      label: "resources.patients",
      icon: <PeopleOutlined />,
    },
  },
  {
    name: "analytics",
    list: "/analytics",
    meta: {
      label: "resources.analytics",
      icon: <AssessmentOutlined />,
      requiredRoles: ["OrgAdmin"],
    },
  },
  {
    name: "organization-settings",
    meta: {
      label: "resources.organizationSettings",
      requiredRoles: ["OrgAdmin"],
    },
  },
];
